import React from 'react';
import { PropTypes } from 'prop-types';

import { t } from 'i18next';
// import Raven from 'raven-js';
import * as Sentry from '@sentry/browser';

import oopsImg from 'assets/images/oops.png';

import './style.scss';

class ErrorBoundary extends React.Component {
  static propTypes = {
    children: PropTypes.any.isRequired,
  };

  constructor(props) {
    super(props);

    this.state = {
      hasError: false,
    };

    this.handleGoHome = this.handleGoHome.bind(this);
  }

  componentDidCatch(err, extra) {
    this.setState({ hasError: true });
    Sentry.captureException(err, { extra });
  }

  /* eslint-disable */
  handleGoHome() {
    window.ci.web.closePage();
  }
  /* eslint-enable */

  render() {
    const { hasError } = this.state;

    if (hasError) {
      return (
        <div styleName="oops">
          <img src={oopsImg} alt="앗! 문제가 발생했습니다." />
          <p>{t('앗! 문제가 발생했습니다.')}</p>
          <button
            onClick={this.handleGoHome}
            className="full-radius-btn full-radius-btn--fill"
          >
            {t('홈으로 돌아가기')}
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;



// WEBPACK FOOTER //
// ./src/app/components/common/ErrorBoundary/index.jsx